module.exports = __webpack_public_path__ + "img/마그때는깡패가되는거야.d93aa06b.png";